export class Country {
    Id: number;
    Name: string;

    constructor(obj: any) {
      this.Id = obj.id;
      this.Name = obj.name;
    }
  }
